import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getPlatform } from '../../Common/Utils/platforms';

const ExtensionLink = styled.a`
  border: none;
  font-family: 'Fira Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 45px;
  cursor: pointer;
  text-decoration: underline;
`;

interface ExtensionInstallLinkProps {
  className?: string;
  browser?: string;
  buttonText?: string;
  onClick?(): void;
}

const ExtensionInstallLink: React.FC<ExtensionInstallLinkProps> = ({
  className,
  buttonText,
  onClick,
}) => {
  const { t } = useTranslation();

  const platform = getPlatform();

  return (
    <ExtensionLink
      href={platform.link}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={onClick}
    >
      {buttonText ?? t('extension.referral.addButton')}
    </ExtensionLink>
  );
};

export default ExtensionInstallLink;
